import { SVGAttributes } from 'react';

export const JiraProductDiscoveryMarkBrand = (props: SVGAttributes<SVGSVGElement>) => (
	<svg
		width="48"
		height="48"
		viewBox="0 0 48 48"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M28.498 24.4199C28.498 24.4199 28.527 24.9899 28.527 25.7769C28.527 28.7089 26.15 31.0859 23.218 31.0859C20.286 31.0859 17.909 28.7089 17.909 25.7769C17.909 22.8449 20.286 20.4679 23.218 20.4679C24.005 20.4679 24.488 20.4969 24.488 20.4969V10.1209C24.069 10.0869 23.646 10.0659 23.218 10.0659C14.538 10.0659 7.50098 17.1029 7.50098 25.7829C7.50098 34.4629 14.538 41.4999 23.218 41.4999C31.898 41.4999 38.935 34.4629 38.935 25.7829C38.935 25.2829 38.926 24.9359 38.885 24.4209H28.498V24.4199Z"
			fill="url(#paint0_linear_818_557)"
		/>
		<path
			d="M26.885 8.5148C31.247 9.6938 35.609 9.6938 39.971 8.5148C40.286 8.4298 40.569 8.7128 40.484 9.0278C39.305 13.3898 39.305 17.7518 40.484 22.1138C40.569 22.4288 40.286 22.7118 39.971 22.6268C35.609 21.4478 31.247 21.4478 26.885 22.6268C26.57 22.7118 26.287 22.4288 26.372 22.1138C27.551 17.7518 27.551 13.3898 26.372 9.0278C26.287 8.7128 26.57 8.4298 26.885 8.5148Z"
			fill="#1D7AFC"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_818_557"
				x1="21.267"
				y1="27.7329"
				x2="32.158"
				y2="16.8419"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#1D7AFC" />
				<stop offset="1" stopColor="#0055CC" />
			</linearGradient>
		</defs>
	</svg>
);
